module.exports = __webpack_public_path__ + "site/img/5.9c04efd0.jpg";